import {
  Alert,
  AlertIcon,
  AlertDescription,
  useColorModeValue,
  CloseButton,
  Box,
} from "@chakra-ui/react";
import { useState, useMemo } from "react";
import { useNavigate } from "react-router";
import { useCurrentCompanyQuery } from "features/Company/hooks";
import { useMessageListQuery } from "features/Resources/Message/hooks";
import { useMessageTemplateListQuery } from "features/Resources/MessageTemplate/hooks";
import { PEOPLE_TEAM_ROUTES } from "definitions/constants/routeConstants";

export default function MissingMessageServiceBanner() {
  const { data: company } = useCurrentCompanyQuery();
  const [isDismissed, setIsDismissed] = useState(false);
  const navigate = useNavigate();
  const alertTextColor = useColorModeValue("fg.subtle", "inherit");

  // Check if company has no message service
  const hasNoMessageService = !company?.messageService;

  // Query all messages with infinite stale time
  const { data: allMessages } = useMessageListQuery("", {
    enabled: hasNoMessageService,
    staleTime: Infinity,
  });

  // Query all templates with infinite stale time
  const { data: allTemplates } = useMessageTemplateListQuery("", {
    enabled: hasNoMessageService,
    staleTime: Infinity,
  });

  // Check if there are any messages or templates
  const hasMessagesOrTemplates = useMemo(() => {
    const messageCount = allMessages?.length || 0;
    const templateCount = allTemplates?.length || 0;
    return messageCount > 0 || templateCount > 0;
  }, [allMessages, allTemplates]);

  const shouldShow = hasNoMessageService && hasMessagesOrTemplates && !isDismissed;

  if (!company || !shouldShow) return null;

  const handleClick = () => {
    navigate(PEOPLE_TEAM_ROUTES.company.integrations.index);
  };

  return (
    <Alert
      status="error"
      cursor="pointer"
      onClick={handleClick}
      transition="background-color 0.2s"
      position="relative"
    >
      <AlertIcon />
      <Box flex="1">
        <AlertDescription color={alertTextColor} fontSize="sm">
          Slack is not connected and you have some tasks/messages defined. Click to set up Slack integration.
        </AlertDescription>
      </Box>
      <CloseButton
        position="absolute"
        right="8px"
        top="8px"
        onClick={(e) => {
          e.stopPropagation();
          setIsDismissed(true);
        }}
      />
    </Alert>
  );
}
